document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.ua-logo-brands .m-icon-box__icon').forEach(function (element) {
    var link = element.matches('a') ? element : element.closest('a') || element.querySelector('a');
    if (link) {
      link.setAttribute('target', '_blank');
      link.setAttribute('rel', 'noopener noreferrer');
    }
  });

  document.querySelectorAll('.ua-video-content .icon-play').forEach(function (button) {
    var container = button.closest('.ua-video-content');
    var video = container ? container.querySelector('video') : null;

    if (!video) return;

    function showButton() {
      button.hidden = false;
      button.style.display = '';
    }

    function hideButton() {
      button.hidden = true;
    }

    button.addEventListener('click', function () {
      if (video.paused) {
        var playPromise = video.play();

        if (playPromise && typeof playPromise.then === 'function') {
          playPromise.then(hideButton).catch(showButton);
        } else {
          hideButton();
        }
      } else {
        video.pause();
      }
    });

    video.addEventListener('play', hideButton);
    video.addEventListener('pause', showButton);
    video.addEventListener('ended', showButton);
  });
});
